import * as React from 'react';
import { CustomerFacingError, ICustomerFacingErrorOptions } from 'utils/ui/errors';
import { EErrorCode } from 'config/errors-codes';

/**
 * A hook to throw an error in a component so that it can be caught by an error boundary.
 */
export function useError() {
  const [error, setError] = React.useState<CustomerFacingError | null>(null);

  React.useEffect(() => {
    if (error) {
      throw error;
    }
  }, [error]);

  const reportError = (code: EErrorCode, options?: ICustomerFacingErrorOptions) => {
    setError(new CustomerFacingError(code, options));
  };

  return reportError;
}
